<template>
  <div class="content-v2">
    <BreadcrumbV2 :items="breadcrumbItems" />
    <div class="detail-card-v2">
      <div class="detail-img-v2">
        <img :src="caseData.image" :alt="caseData.title" />
      </div>
      <div class="detail-info-v2">
        <h2>{{ caseData.title }}</h2>
        <div class="detail-tags">
          <span>{{ caseData.type }}</span>
          <span>{{ caseData.capacity }}</span>
          <span>{{ caseData.period }}</span>
        </div>
        <div class="case-content" v-html="caseData.desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbV2 from '@/components/BreadcrumbV2.vue'
import { getCaseDetail } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultDebugImage from '@/assets/images/case1.svg'
import defaultOperationImage from '@/assets/images/case2.svg'

export default {
  name: 'CaseDetailV2',
  components: { BreadcrumbV2 },
  data() {
    return {
      caseData: {
        title: '电站调试项目',
        type: '调试项目',
        capacity: '600MW',
        period: '2024-2025',
        image: defaultDebugImage,
        desc: '该项目涵盖了从分系统调试到整套启动的全流程调试服务。公司派出专业技术团队，严格按照国家及行业标准执行，确保了机组的顺利投运。'
      }
    }
  },
  computed: {
    isOperationDetail() {
      return this.$route.path.includes('/operation/')
    },
    breadcrumbItems() {
      return [
        { nameKey: 'common.cases', path: '/cases' },
        this.isOperationDetail
          ? { nameKey: 'common.operationCases', path: '/cases/operation' }
          : { nameKey: 'common.debugCases', path: '/cases/debug' }
      ]
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.caseData.title = (this.$route.path.includes('debug') ? '调试' : '运维') + '案例 ' + id
        this.loadDetail()
      }
    }
  },
  methods: {
    loadDetail() {
      const id = this.$route.params.id
      if (!id) {
        return
      }
      getCaseDetail(id).then(data => {
        if (!data || !data.caseId) {
          return
        }
        const isOperation = data.caseType === 'operation' || this.$route.path.includes('operation')
        this.caseData = {
          title: data.caseTitle,
          type: isOperation ? '运维项目' : '调试项目',
          capacity: data.serviceScope || data.projectLocation || '',
          period: data.publishDate || '',
          image: resolveFileUrl(data.coverUrl, isOperation ? defaultOperationImage : defaultDebugImage),
          desc: data.caseContent || data.summary || ''
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-card-v2 {
  display: flex;
  gap: 50px;
  background: #fff;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.06);

  .detail-img-v2 {
    width: 400px;
    flex-shrink: 0;
    border-radius: 16px;
    overflow: hidden;

    img {
      width: 100%;
      display: block;
    }
  }

  .detail-info-v2 {
    flex: 1;

    h2 {
      font-size: 28px;
      font-weight: 700;
      color: #0f172a;
      margin-bottom: 20px;
    }

    .detail-tags {
      display: flex;
      gap: 10px;
      margin-bottom: 24px;

      span {
        padding: 6px 16px;
        background: #f1f5f9;
        color: #3b82f6;
        font-size: 13px;
        font-weight: 600;
        border-radius: 20px;
      }
    }

    .case-content {
      font-size: 17px;
      line-height: 2;
      color: #475569;

      ::v-deep p {
        margin-bottom: 16px;
      }
    }
  }
}

@media (max-width: 960px) {
  .detail-card-v2 {
    flex-direction: column;

    .detail-img-v2 {
      width: 100%;
    }
  }
}
</style>
